import { useContent, html } from '@/content';

export default function ServicesSection() {
  const c = useContent();
  return (
    <section id="leistungen" className="py-20 md:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16 animate-on-scroll">
          <p className="text-xs tracking-[0.3em] uppercase text-champagne-500 font-medium mb-3">
            {c.services.eyebrow}
          </p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-gray-800 mb-4">
            {c.services.title}
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            {c.services.subtitle}
          </p>
        </div>

        {/* Price list as styled text */}
        <div className="max-w-3xl mx-auto space-y-10">
          {/* Gesichtsbehandlungen */}
          <div className="animate-on-scroll delay-100">
            <h3 className="font-display text-xl md:text-2xl text-gray-800 mb-6 flex items-center gap-3">
              <span className="w-8 h-[2px] bg-champagne-400"></span>
              {c.services.groupFace}
            </h3>
            <div className="space-y-4">
              {c.services.face.map((item, i) => (
                <div key={i} className="bg-blush-50/40 rounded-xl p-5 border border-blush-100 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2">
                  <div>
                    <p className="font-medium text-gray-800" {...html(item.name)} />
                    <p className="text-sm text-gray-500 mt-1">{item.desc}</p>
                  </div>
                  <span className="font-display text-lg text-champagne-500 whitespace-nowrap sm:text-right">{item.price}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Spezialbehandlungen */}
          <div className="animate-on-scroll delay-200">
            <h3 className="font-display text-xl md:text-2xl text-gray-800 mb-6 flex items-center gap-3">
              <span className="w-8 h-[2px] bg-champagne-400"></span>
              {c.services.groupSpecial}
            </h3>
            <div className="space-y-4">
              {c.services.special.map((item, i) => (
                <div key={i} className="bg-champagne-50/40 rounded-xl p-5 border border-champagne-100 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2">
                  <div>
                    <p className="font-medium text-gray-800" {...html(item.name)} />
                    <p className="text-sm text-gray-500 mt-1" {...html(item.desc)} />
                  </div>
                  <span className="font-display text-lg text-champagne-500 whitespace-nowrap sm:text-right">{item.price}</span>
                </div>
              ))}

              <div className="bg-champagne-100/60 rounded-xl p-5 pt-6 border-2 border-champagne-300 relative overflow-visible">
                <div className="absolute -top-3 right-4 bg-champagne-500 text-white text-[10px] tracking-widest uppercase font-bold px-4 py-1 rounded-full shadow-md">
                  {c.services.meso.badge}
                </div>
                <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2">
                  <div>
                    <p className="font-medium text-gray-800 text-base" {...html(c.services.meso.name)} />
                    <p className="text-sm text-gray-500 mt-1">{c.services.meso.desc}</p>
                  </div>
                  <div className="flex flex-col items-end gap-1 whitespace-nowrap sm:text-right">
                    <div className="flex items-center gap-3">
                      <span className="font-display text-lg text-gray-400 line-through">{c.services.meso.priceOld}</span>
                      <span className="font-display text-xl text-champagne-600">{c.services.meso.priceNew}</span>
                    </div>
                    <p className="text-[11px] text-champagne-500 font-medium">{c.services.meso.note}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Augenblicke */}
          <div className="animate-on-scroll delay-300">
            <h3 className="font-display text-xl md:text-2xl text-gray-800 mb-6 flex items-center gap-3">
              <span className="w-8 h-[2px] bg-champagne-400"></span>
              {c.services.groupEyes}
            </h3>
            <div className="space-y-3">
              {c.services.eyes.map((item, i) => {
                const last = i === c.services.eyes.length - 1;
                return (
                  <div
                    key={i}
                    className={`flex items-center justify-between py-3 ${last ? '' : 'border-b border-blush-100'}`}
                  >
                    <span className={last ? 'text-gray-600 font-medium' : 'text-gray-600'} {...html(item.name)} />
                    <span className="font-display text-lg text-champagne-500 whitespace-nowrap ml-4">{item.price}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-14 text-center animate-on-scroll delay-300">
          <p className="text-gray-500 text-sm mb-4">
            {c.services.ctaText}
          </p>
          <a
            href="#kontakt"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('kontakt')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 bg-champagne-500 text-white px-8 py-3 rounded-full text-sm font-medium hover:bg-champagne-600 transition-colors shadow-md whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-mail-line text-xs"></i>
            </div>
            {c.services.ctaButton}
          </a>
        </div>
      </div>
    </section>
  );
}